// Layout dos cards da lista de tickets, definido por .env:
//   REACT_APP_TICKET_CARD_LAYOUT=default  -> fila em texto + ícone da conexão (padrão)
//   REACT_APP_TICKET_CARD_LAYOUT=badges   -> fila e conexão como dois badges coloridos
const raw = String(process.env.REACT_APP_TICKET_CARD_LAYOUT || "default")
  .trim()
  .toLowerCase();

export const TICKET_CARD_LAYOUT = raw === "badges" ? "badges" : "default";

export const isBadgesTicketCardLayout = TICKET_CARD_LAYOUT === "badges";

export default TICKET_CARD_LAYOUT;
